// Content types the UI loads inline as text. `message/http` covers routed
// steps, whose input (HTTP request) and output (HTTP response) are ASCII
// headers + a text body — loading them lets step-test capture read
// routed runs.
export function isInlineTextContentType(contentType: string): boolean {
  return (
    contentType.startsWith("text/") ||
    contentType === "application/json" ||
    contentType === "message/http"
  );
}
